import { render, staticRenderFns } from "./PatientAnalytics.vue?vue&type=template&id=71409620&scoped=true"
import script from "./PatientAnalytics.vue?vue&type=script&lang=js"
export * from "./PatientAnalytics.vue?vue&type=script&lang=js"
import style0 from "./PatientAnalytics.vue?vue&type=style&index=0&id=71409620&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71409620",
  null
  
)

export default component.exports